$(document).ready(function (){

    /*Таймер товар недели на детальной стр товара*/
    $("#counterProductsOfWeek_detail")
        .countdown("2024/12/31", function(event) {

            /*функция склонения "дней" */
            function dayTitle(number) {
                if (number > 10 && [11, 12, 13, 14].includes(number%100)) return 'дней';
                last_num = number%10;
                if (last_num == 1) return 'день';
                if ([2,3,4].includes(last_num)) return 'дня';
                if ([5,6,7,8,9, 0].includes(last_num)) return 'дней';
            }

            /*количество дней*/
            var $c_days_num = event.strftime('%-D');

            var $this = $(this).html(event.strftime(''
                + '<div class="pt-value">%-D ' + dayTitle($c_days_num) + '</div> '
                + '<div class="pt-value">%H</div> '
                + '<div class="pt-value">%M</div> '
                + '<div class="pt-value">%S</div>'));
        });
});
